export const regExp = {
  email: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
}